export default __webpack_public_path__ + "static/media/hht1_song_18.3baf7e1f.png";